import CardWithTitle from 'components/atoms/CardWithTitle'
import NoticeConfirmDialog from 'components/Dialog/NoticeConfirmDialog'
import PageTable from 'pages/Analysis/EEGNorm/PageTable'
import React from 'react'

function EEGNorm() {
  return (
    <>
      <CardWithTitle>
        <PageTable />
      </CardWithTitle>
      <NoticeConfirmDialog />
    </>
  )
}

export default EEGNorm
